export default __webpack_public_path__ + "static/media/PublicTonic.93d7d96b1105817513ea713ed58f6ed3.webp";